import { fetchData } from '../fetchService';
import {
	AuthKeys,
	PublicKey,
	AuthenticateResponse,
	CreateKeyPairResponse,
	RegisterResponse,
	ListPublicKeysResponse,
	GetApiKeyInfoResponse,
	GetListByPrincipalRequest,
	SingOutRequest,
	ResponseWitOutData,
} from '../types';
import { toSearchParams } from '../helpers/common';

const authService = {
	async signUp(baseUrl: string): Promise<RegisterResponse> {
		return await fetchData(
			`${baseUrl}/owner`,
			'POST',
			null,
			{},
			{
				'x-bs-edge-sign':
					'8BC0D2DE9A537CCA1598491DD82C9020F06BCDB1D7C0080B136344F4CBFA7F727FEC8351CE724E34ADD9CDB4D9F753DE58015E2C9FA02AB280CDAAEA4C57D60E',
				'x-bs-edge-sign-nonce': '1',
				'x-bs-edge-sign-timestamp': '1',
				'Content-Type': 'application/json',
			},
		);
	},
	async authInfo(
		baseUrl: string,
		authKeys?: AuthKeys,
	): Promise<GetApiKeyInfoResponse> {
		return await fetchData(`${baseUrl}/context`, 'GET', null, authKeys);
	},
	async signInPrincipal(
		baseUrl: string,
		principal: string,
		authKeys?: AuthKeys,
	): Promise<AuthenticateResponse> {
		return await fetchData(
			`${baseUrl}/token?principal=${principal}`,
			'POST',
			null,
			authKeys,
		);
	},
	async signOutPrincipal(
		baseUrl: string,
		data: SingOutRequest,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/token${query ? `?${query}` : ''}`,
			'POST',
			null,
			authKeys,
		);
	},
	async creatKeyPrincipal(
		baseUrl: string,
		principal: string,
		authKeys?: AuthKeys,
	): Promise<CreateKeyPairResponse> {
		return await fetchData(
			`${baseUrl}/keypair?principal=${principal}`,
			'POST',
			null,
			authKeys,
		);
	},
	async deleteKeyPrincipal(
		baseUrl: string,
		principal: string,
		data: PublicKey,
		authKeys?: AuthKeys,
	): Promise<CreateKeyPairResponse> {
		return await fetchData(
			`${baseUrl}/keypair?principal=${principal}`,
			'DELETE',
			data,
			authKeys,
		);
	},
	async getListKeyPrincipal(
		baseUrl: string,
		data: GetListByPrincipalRequest,
		authKeys?: AuthKeys,
	): Promise<ListPublicKeysResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/keypair/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default authService;
